<template>
  <div>
    <label
      for="mobile"
      class="h6"
      :style="`color: ${isMobilePhoneValid ? 'rgba(0, 0, 0, 0.6)' : '#c71900'};`"
    >Mobile*</label>
    <vue-tel-input
      :field="field"
      :value="modelValue"
      :input-options="{
        id: field.name,
        required: !!field.required,
        readonly: !!field.readonly,
        name: `_${ field.name }`,
        placeholder: field.label
      }"
      valid-characters-only
      mode="international"
      default-country="fr"
      :preferred-countries="['FR']"
      class="mt-1"
      @input="handleChanges"
      @validate="handleValidation"
    />
  </div>
</template>

<script>
export default {
  name: 'MobilePhoneInput',
  props: {
    field: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isMobilePhoneValid: false,
      modelValue: this.value
    };
  },
  watch: {
    value (newValue) {
      this.modelValue = newValue || '';
    }
  },
  methods: {
    handleValidation (vueTelPhoneObject) {
      this.isMobilePhoneValid = vueTelPhoneObject.valid;
    },
    handleChanges (value) {
      const validatedValue = this.isMobilePhoneValid ? value : null;

      this.$emit('input', validatedValue);
    }
  }
};
</script>
